export default __webpack_public_path__ + "static/media/classroomImg1.70d1227a.svg";